import { Service } from "typedi";
import { DomMethods } from "../../../../../application/core/shared/dom-methods/DomMethods";
import { IApplePayButtonFactory } from "./IApplePayButtonFactory";
import { isNativeSafari } from "../../ApplePayClient";
import { APPLE_PAY_BUTTON_ATTRIBUTE } from "./ApplePayButtonProperties";

@Service()
export class OfficialApplePayButtonFactory implements IApplePayButtonFactory {
  public create(label: string, style: string): HTMLElement {
    // Safari has native support for -webkit-appearance: -apple-pay-button on standard HTML elements
    // Non-Safari browsers (Windows Chrome/Edge) use the <apple-pay-button> custom element provided by Apple's SDK
    const button = isNativeSafari
      ? this.createSafariButton(label, style)
      : this.createStandardButton(label, style);

    button.setAttribute(APPLE_PAY_BUTTON_ATTRIBUTE, "true");
    return button;
  }

  private createSafariButton(label: string, style: string): HTMLElement {
    return DomMethods.createHtmlElement.apply(this, [
      {
        style: `
                  -webkit-appearance: -apple-pay-button;
                  -apple-pay-button-type: ${label ? label : "plain"};
                  -apple-pay-button-style: ${
                    style ? style : "black"
                  };pointer-events: auto;cursor: pointer;display: flex;role: button;`,
      },
      "a",
    ]);
  }

  private createStandardButton(label: string, style: string): HTMLElement {
    // Apple Pay locale requires aa-AA format (BCP 47)
    // HTML lang can be just 'de', navigator.language is always BCP 47 e.g. 'de-DE'
    const htmlLang = document.documentElement.lang || "";
    const isFullLocale = /^[a-z]{2}-[A-Z]{2}$/.test(htmlLang);
    const locale = isFullLocale ? htmlLang : navigator.language || "en";

    const button = document.createElement("apple-pay-button");
    button.setAttribute("buttonstyle", style || "black");
    button.setAttribute("type", label || "plain");
    button.setAttribute("locale", locale);
    button.style.display = "flex";
    button.style.width = "100%";
    return button;
  }
}
